import { gql } from '@apollo/client';

export default class ContractMutation {
    static SET_DEFAULT_LOAN_CONTRACT_TEMPLATE = gql`
        mutation setDefaultLoanContractTemplate($id: Int!) {
            setDefaultLoanContractTemplate(loanContractTemplateId: $id)
        }
    `;

    static CLONE_LOAN_CONTRACT_TEMPLATE = gql`
        mutation cloneLoanContractTemplate($loanContractTemplateId: Int!) {
            cloneLoanContractTemplate(loanContractTemplateId: $loanContractTemplateId) {
                loanContractTemplateId
            }
        }
    `;

    static UPDATE_LOAN_CONTRACT_TEMPLATE = gql`
        mutation UpdateLoanContractTemplate(
            $loanContractTemplateId: Int!
            $input: LoanContractTemplateUpdateInput!
        ) {
            updateLoanContractTemplate(
                loanContractTemplateId: $loanContractTemplateId
                input: $input
            )
        }
    `;
}
